import React, { Component } from 'react';
import {
	Box,
	Center,
    Flex,
    Spacer,
    HStack,
    VStack,
    Image,
    Text,
    Wrap,
    WrapItem,
    Link,
} from "@chakra-ui/react"

import useWindowSize from '../../hooks/useWindowSize'
import { XIcon, GIcon, EmailIcon, ZhihuIcon, GithubIcon, IGIcon, ColabIcon } from '../../icons'

function Intro(props) {

    const { width } = useWindowSize();
    const lfs = props.fontSizes['large'];
    const sfs = props.fontSizes['small'];

	return (
		<Center 
			w="100%" 
			bg="#1F1F21"
			position="relative"
        >
            <Box
                h="100%"
                w="100%"
                maxWidth="928px"
                // bg="#000000"
                // borderTop="3px solid rgba(255, 255, 255, 0.1)"
                margin="36px 24px 0 24px"
            >
                {/* <HStack> */}
                <Text position="relative" fontSize={lfs} lineHeight="24px" color="#FFFFFF" fontWeight="500" margin="0 0 10px 10px">
                    About
                </Text>
                <Box h="3px" w="100%" bg="rgba(255, 255, 255, 0.1)" />
                <Text fontFamily="Catamaran" position="relative" fontSize='18px' lineHeight="24px" color="#BBBBBB" fontWeight="400" margin="10px 10px 10px 10px" textAlign="justify">
                My research focuses on developing neural network models that bridge the gap between machine intelligence and the physical world. This includes intelligent learning for medical image analysis to improve clinical translation and advancing wearable AI devices through efficient vision-language models.
                I am dedicated to building <b><span style={{ color: "#EE7D85" }}>Ultrahand</span></b>, a tool evolving toward world models and designed to further connect machine intelligence with the physical world.
                </Text>
            </Box >

		</Center>
	)
}

export default Intro;